import { Component, OnInit, OnDestroy } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidationErrors } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { PasswordPolicyValidator } from "../../directives/security-policy-validator.directive";
import { AuthService } from "../../services/auth.service";
import swal from "sweetalert2";

@Component({
  selector: 'forgotten-password-reset',
  templateUrl: './forgotten-password-reset.component.html',
  host: { 'class': 'login-main' }
})
export class ForgottenPasswordResetComponent implements OnInit, OnDestroy {

  form: UntypedFormGroup;
  passwords: UntypedFormGroup;
  submitting: boolean = false;
  submitted: boolean = false;
  routeSubscription: Subscription;
  private guid1: string = '';
  private guid2: string = '';

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {

    this.form = fb.group({
      'passwords': fb.group({
        'password': [null, Validators.compose([Validators.required, PasswordPolicyValidator])],
        'passwordAgain': [null, Validators.compose([Validators.required])]
      }, { validator: this.passwordsMatch })
    })

    this.passwords = this.form.controls["passwords"] as UntypedFormGroup;
  }

  ngOnInit() {
    this.routeSubscription = this.route.params.subscribe(params => {
      this.guid1 = params.guid1;
      this.guid2 = params.guid2;
    });
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

  passwordsMatch(group: UntypedFormGroup): ValidationErrors | null {
    let match = group.controls['password'].value === group.controls['passwordAgain'].value;
    return match ? null : { 'passwordsMatch': { value: group.controls['passwordAgain'].value } };
  }

  submit(form: UntypedFormGroup) {
    this.submitted = true;
    if (form.invalid) return;
    this.submitting = true;
    form.disable();

      this.authService.resetPassword(this.guid1, this.guid2, this.passwords.controls.password.value).then(success => {
      this.router.navigate(['/auth/forgotten-password/completed']);
    }, error => {
      this.submitting = false;
      form.enable();
        
      swal(
        'Error',
        error.description ? error.description : 'Please try again',
        'error'
      );
    });
  }

}
